<template>
  <div class="contact-us">
    <el-carousel height="410px" class="swImg" arrow="never">
      <el-carousel-item v-for="(item, index) in imgList" :key="index" class="pointer">
        <img style="height: 100%;" :src="item.img" @click="nav(item)" />
      </el-carousel-item>
    </el-carousel>
    <div class="s_r">
      <div class="z_l">
        <div></div>联系我们
      </div>
      <div class="llll"></div>
    </div>
    <div class="ma">
      <div class="sss">
        <img :src="logo" alt="">
      </div>
         <div class="info-box">
     
      <ul class="contact-list">
        <li>
           <img style="width: 15px;margin-right: 8px;"
              src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x56.png" alt="">
          <span class="label">学校名称</span>
          <span class="value">{{infoDomain.name}}</span>
        </li>
        <li>
        <img style="width: 15px;margin-right: 8px;"
              src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x57.png" alt="">
          <span class="label">联系电话</span>
          <span class="value">{{ infoDomain.mobile }}</span>
        </li>
        <li>
           <img style="width: 15px;margin-right: 8px;"
              src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x58.png" alt="">
          <span class="label">联系地址</span>
          <span class="value">{{ members.address }}</span>
        </li>
        <li>
          <img style="width: 15px;margin-right: 8px;"
              src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x57.png" alt="">
          <span class="label">联系邮箱</span>
          <span class="value">{{ members.mail }}</span>
        </li>
      </ul>
    </div>
    <div class="img-box">
                <img :src="members.imgUrl" alt="">

    </div>
    </div>
  
  </div>
</template>

<script>
import { getDomain, getDomainLogo } from '@/api/cookies'
import { TeacherClient } from '@/api/teacherClient.js'
import { getSurfaceList, } from "@/api/home";
let teacherClient = new TeacherClient()
export default {
  name: "ContactUs",
  data() {
    return {
      members: '',
      logo: '',
      imgList: '',
      infoDomain: ''

    };
  },
  created() {
    this.infoDomain = getDomain()
    console.log(this.infoDomain,'this.infoDomain');
    
    this.getList()
    this.logo = getDomainLogo()


  },
  methods: {

    async getList() {
      teacherClient.getEntrantsRelation({

      }).then((res) => {
        this.members = res.data
      })
      getSurfaceList(18, undefined, this.infoDomain.entrantsType).then((res) => {
        if (res.code == 0) {
          this.imgList = JSON.parse(JSON.stringify(res.msg));
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.swImg {
  width: 100%;
}

.s_r {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;

  .z_l {
    display: flex;
    align-items: center;

    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 20px;
    color: #0074ef;

    div {
      width: 15px;
      height: 15px;
      background: linear-gradient(180deg, #0073ff 0%, #0057c9 100%);
      border-radius: 2px 2px 2px 2px;
      margin-right: 8px;
    }
  }

  .llll {
    width: 100%;
    height: 2px;
    background: #0074ef;
    border-radius: 0px 0px 0px 0px;
    margin-top: 12px;
    margin-bottom: 20px;
  }


}

.ma {
  width: 1200px;height: 327px;
  display: flex;
 background: #FFFFFF;
  border-radius: 12px;
  padding: 24px;
  align-items: flex-end; 
  margin: 0 auto;
  margin-top: 20px;
  position: relative;
  margin-bottom: 80px;
.sss{
  top: 40px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 300px;
height: 58px;
background: linear-gradient( 180deg, #338DFF 0%, #1079FF 100%);
border-radius: 12px 12px 12px 12px;
img{
  max-width: 252px;
height: 38px;
border-radius: 0px 0px 0px 0px;
}
}
  .info-box {
   width: 561px;
height: 233px;
background: #F5F9FC;
border-radius: 12px 12px 12px 12px;
    padding: 32px;
    padding-top: 61px;

    

    .contact-list {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        font-size: 14px;
        color: #333;

        i {
          font-size: 18px;
          color: #4a90e2;
          margin-right: 8px;
          width: 20px;
          text-align: center;
        }

        .label {
       
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 15px;
color: #777777; 
        }

        .value {
       
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 15px;
color: #333333; 
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-left: 16px;
        }
      }
    }
  }

  .img-box {
    flex: 1;
    margin-left: 24px;

    img {
      width: 567px;
      height: 280px;
      object-fit: cover;
      border-radius: 8px;
      box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
    }
  }
}
</style>